import clsx from "clsx";

export default function Skeleton({
  height,
  width,
  text,
  className,
  applyGradient,
}: {
  applyGradient?: boolean;
  className?: string;
  height: string;
  text?: string;
  width: string;
}) {
  return (
    <div
      className={clsx(
        "bg-gray-200 animate-pulse rounded flex justify-center items-center",
        height,
        width,
        className,
        applyGradient && "bg-gradient-to-b from-gray-200 to-gray-50",
      )}
      data-testid="skeleton-elem"
    >
      {text && <span className="text-gray-900 text-xs">{text}</span>}
    </div>
  );
}
